import scaleDecimal from './scaleDecimal';

const roundNearest = (num, step) => {
  return (Math.round(num / step) * step).toFixed(scaleDecimal(step));
};

export default roundNearest;
